<div mat-dialog-title>{{ data.title }}</div>

<mat-dialog-content>
	<div>{{ data.statement }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-flat-button color="primary" mat-dialog-close>OK</button>
</mat-dialog-actions>
